<template>
  <div>
    <div class="add-box common-shadow">
      <vxe-table
        border="none"
        show-overflow
        :auto-resize="true"
        align="center"
        :data="tableData"
      >
        <vxe-table-column field="sellerName" title="承运人" width="15%">
          <template slot-scope="{ row }">
            <a @click="openUserInfo(row)" v-if="isHavePermission('ordersTwo:showSellerDetail')">{{ row.sellerName }}</a>
            <span v-else>{{ row.sellerName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerIncludeTax" title="含税" width="5%">
          <template v-slot="{ row }">
            <span>{{ row.sellerIncludeTax | taxMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerPrice" title="单价" width="10%"></vxe-table-column>
        <vxe-table-column field="sellerAmount" :title="detailData && detailData.busType === 4 ? '总金额' :'运费金额'" width="10%"></vxe-table-column>

        <vxe-table-column field="payAmount" title="应付账款" width="10%"> </vxe-table-column>
        <vxe-table-column field="payedAmount" title="已付金额" width="10%"> </vxe-table-column>
        <vxe-table-column field="unpayAmount" title="未付金额" width="10%"></vxe-table-column>
        <vxe-table-column
          field="sellerInvoiceAmount"
          title="关联发票金额"
          width="10%"
        ></vxe-table-column>
        <vxe-table-column field="sellerContractNum" title="关联合同" width="10%">
          <template slot-scope="{ row }">
            <span @click="showDetail(row)" style="color: #2d8cf0; cursor: pointer">{{
              row.sellerContractNum
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerSettlementFiles" title="附件" width="10%">
          <template v-slot="{ row }">
            <upload-detail :arrList="row.sellerSettlementFiles"></upload-detail>
          </template>
        </vxe-table-column>
      </vxe-table>
      <!-- <vxe-table
        border="none"
        show-overflow
        class="table-style"
        :auto-resize="true"
        align="center"
        :data="tableData"
      >
        <vxe-table-column field="payAmount" title="应付账款" width="25%">
        </vxe-table-column>
        <vxe-table-column field="payedAmount" title="已付金额" width="25%">
        </vxe-table-column>
        <vxe-table-column
          field="unpayAmount"
          title="余额"
          width="25%"
        ></vxe-table-column>
        <vxe-table-column
          field="sellerInvoiceAmount"
          title="关联发票金额"
          width="25%"
        ></vxe-table-column>
      </vxe-table> -->
    </div>
    <vxe-modal
      v-model="userInfoModal"
      width="1400"
      height="800"
      position="center"
      title="查看用户信息"
      destroy-on-close
    >
      <user-center
        :userId="editUserId"
        :userType="userType"
        :isUserEdit="false"
        :userName="userName"
        ref="userCenter"
      ></user-center>
    </vxe-modal>
    <vxe-modal
      v-model="createModal"
      :title="modalTitle"
      width="1300"
      height="400"
      @close="closeCreate"
      resize
      position="center"
    >
      <create ref="modalCreate"></create>
    </vxe-modal>
    <vxe-modal
      v-model="detailModal"
      title="合同详情"
      width="1000"
      height="900"
      position="center"
      @close="closeDetail"
      resize
    >
      <contract-detail ref="detailModal" @close="closeDetail"></contract-detail>
    </vxe-modal>
  </div>
</template>

<script>
import UploadDetail from "@/components/common/UploadDetail";
import UserCenter from "@/views/account/UserCenter";
import { apiGet } from "@/utils/api";
import Create from "@/components/order2.0/Agreement/CreateModal";
import getAuthOrization from "@/mixin/getAuthOrization";
import ContractDetail from "@/views/contracts/contractDetail";
export default {
  mixins: [getAuthOrization],
  props: {
    detailData: Object,
  },
  components: {
    UploadDetail,
    UserCenter,
    Create,
    ContractDetail,
  },
  watch: {
    detailData(val) {
      if (val) {
        this.tableData = [
          {
            sellerContractId: val.sellerContractId,
            sellerName: val.sellerName,
            sellerIncludeTax: val.sellerIncludeTax,
            sellerPrice: val.sellerPrice,
            sellerAmount: val.sellerAmount,
            sellerContractNum: val.sellerContractNum,
            sellerSettlementFiles: val.sellerSettlementFiles,
            payAmount: val.payAmount,
            payedAmount: val.payedAmount,
            unpayAmount: val.unpayAmount,
            sellerInvoiceAmount: val.sellerInvoiceAmount,
            sellerId: val.sellerId,
            sellerContractCate: val.sellerContractCate,
            sellerContractType: val.sellerContractType
          },
        ];
      }
    },
  },
  data() {
    return {
      tableData: [
        {
          sellerName: null,
          sellerIncludeTax: null,
          sellerPrice: null,
          sellerAmount: null,
          sellerContractNum: null,
          sellerSettlementFiles: null,
          payAmount: null,
          payedAmount: null,
          unpayAmount: null,
          sellerInvoiceAmount: null,
          sellerContractCate: null,
          sellerContractType: null
        },
      ],
      userInfoModal: false,
      editUserId: null,
      userType: null,
      userName: null,
      createModal: false,
      modalTitle: "",
      detailModal: false,
    };
  },
  methods: {
    closeDetail() {
      this.detailModal = false;
    },
    showDetail(row) {
      // sellerContractId
      if (!this.isHavePermission("agreement2.0:showDetail")) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！",
        });
        return;
      }
      if (row.sellerContractCate === 2) {
        this.modalTitle = "合同详情";
        this.createModal = true;
        this.$refs.modalCreate.queryContractDetail(row.sellerContractId);
        this.$refs.modalCreate.showDetail();
        this.$refs.modalCreate.orderShow();
      } else if (row.sellerContractCate === 3) {
        this.detailModal = true;
        this.$refs.detailModal.orderOpen(row.sellerContractId, row.sellerContractType);
      }
    },
    closeCreate() {
      this.$refs.modalCreate.close();
    },
    async openUserInfo(row) {
      let id = row.sellerId;
      let res = await apiGet("api/auth/", "baseUserSign/getUserSignById", {
        userId: id,
      });
      if (res.status === 1) {
        this.userType = res.data.userType;
        this.editUserId = id;
        this.userName = row.sellerName;
        this.userInfoModal = true;
      } else {
        this.$Modal.error({
          title: "错误提示",
          content: res.message,
        });
      }
    },
  },
};
</script>

<style></style>
